import DataModule from "@/components/DataModule";
import { inr } from "@/lib/api";
import { Badge } from "@/components/ui/badge";

const CATEGORIES = [
  "Rent", "Utilities", "Salaries", "Travel", "Marketing", "Supplies",
  "Equipment", "Software", "Maintenance", "Professional Fees", "Taxes",
  "Insurance", "Materials", "Labor", "Other",
];

export default function Expenses() {
  return (
    <DataModule
      title="Expenses"
      subtitle="Track operational costs, vendor payments, recurring bills"
      endpoint="expenses"
      pageTestId="expenses-page"
      initialRecord={{ expense_date: new Date().toISOString().slice(0, 10) }}
      fields={[
        { key: "category", label: "Category", type: "select", options: CATEGORIES, required: true },
        { key: "amount", label: "Amount", type: "number", required: true },
        { key: "vendor", label: "Vendor / Paid to" },
        { key: "payment_method", label: "Method", type: "select", options: ["Cash", "UPI", "Cheque", "Card", "Bank Transfer"] },
        { key: "expense_date", label: "Date", type: "date" },
        { key: "reference", label: "Reference / Bill No." },
        { key: "notes", label: "Notes", type: "textarea", full: true },
      ]}
      columns={[
        { key: "category", label: "Category", render: (e) => <Badge variant="secondary">{e.category}</Badge> },
        { key: "vendor", label: "Vendor" },
        { key: "amount", label: "Amount", render: (e) => <span className="font-semibold">{inr(e.amount)}</span> },
        { key: "payment_method", label: "Method" },
        { key: "expense_date", label: "Date" },
      ]}
    />
  );
}
